/**
 * Splits a message into an array split by the tokens.
 * @example
 * splitIntoTokens("You won {MINI} and {MAJOR}", ["{MINI}, {MAJOR}"]) = ["You won ", "{MINI}", " and ", "{MAJOR}"]
 */
export function splitIntoTokens(message, tokens) {
    message ?? (message = "");
    // Escape the { and } so they won't trip regex behaviour.
    const escapedTokens = tokens.map(token => token.replace("{", "\\{").replace("}", "\\}"));
    // Split the message through the tokens, filtering empty strings.
    return message.split(new RegExp(`(${escapedTokens.join('|')})`, 'g')).filter(Boolean);
}
//# sourceMappingURL=TokenSplitter.js.map